/**
 * Communication format for actions from Editor Window to Preview Iframe and vice versa.
 * */

export function createActionPayload<T>(name: string, data: T) {
    return { action: { name, data } };
}
